
import {
  formatDateNumber,
  parsingErrorResponse
} from "@/app/infrastructures/misc/Utils";
import DateRangePicker from "@/app/ui/components/date-range-picker/index.vue";
import { Range } from "@/app/ui/components/date-range-picker/type";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { PickupDashboardController } from "@/app/ui/controllers/PickupDashboardController";
import { ReportController } from "@/app/ui/controllers/ReportController";
import { ExportApiRequest } from "@/data/payload/api/PickupDashboardApiRequest";
import { Options, Vue } from "vue-class-component";

@Options({
  components: { DateRangePicker }
})
class PickupDashboardMonitoring extends Vue {
  dateRange = new Range();

  async onDownload() {
    try {
      MainAppController.showLoading();

      await PickupDashboardController.export(
        new ExportApiRequest({
          startDate: formatDateNumber(this.dateRange.start),
          endDate: formatDateNumber(this.dateRange.end),
        })
      );

      await ReportController.onGetListDownloadReport();
      ReportController.setOpenDownloadRequest(true);
    } catch (err) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(err, "Gagal Download Data !", this.onDownload)
      );
    } finally {
      MainAppController.closeLoading();
    }
  }
}
export default PickupDashboardMonitoring;
